var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wrench",
    clipPath: "url(#clip0_21653_883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.12499 9.91728C7.62536 9.0131 7.41805 7.97636 7.53157 6.94958C7.64509 5.92279 8.07387 4.95638 8.75895 4.18318C9.44403 3.40998 10.3518 2.86796 11.3574 2.63163C12.3631 2.39529 13.4172 2.47625 14.375 2.86337L11.25 6.25009L11.6922 8.3079L13.75 8.75009L17.1367 5.62509C17.5238 6.58285 17.6048 7.63701 17.3685 8.64266C17.1321 9.6483 16.5901 10.5561 15.8169 11.2411C15.0437 11.9262 14.0773 12.355 13.0505 12.4685C12.0237 12.582 10.987 12.3747 10.0828 11.8751L5.70311 16.9532C5.35087 17.3055 4.87313 17.5033 4.37499 17.5033C3.87684 17.5033 3.3991 17.3055 3.04686 16.9532C2.69462 16.601 2.49673 16.1232 2.49673 15.6251C2.49673 15.1269 2.69462 14.6492 3.04686 14.297L8.12499 9.91728Z",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21653_883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/Wrench.870dc946fb6629b3f919adec276454e7.svg";
export { ForwardRef as ReactComponent };